const state = {
  categories: [],
  topCategories: [],
  isAppLoading: false,
  quickViewProduct: null
}

export default state
